import { GetQueryByIdParams } from '../../types';
import { User } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const getUserById = async (
  params: GetQueryByIdParams<User>
): Promise<User> => {
  return await tinctApi.users.getUser(params);
};


export const useGetUserById = (
  params: GetQueryByIdParams<User>,
  options?: Omit<UseQueryOptions<User, ApiError>, "queryKey">,
) =>
  useQuery({
    queryKey: [params.id, params.fields],
    queryFn: () => getUserById(params),
    ...options,
  });
